import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { DxButtonModule, DxTextBoxModule, DxPopupModule, DxScrollViewModule, DxToastModule } from 'devextreme-angular';
import { CtlTmsTasinirGirisBakiyeAramaComponent } from './ctl-tms-tasinir-giris-bakiye-arama/ctl-tms-tasinir-giris-bakiye-arama.component';
import { TmsTasinirGirisBakiyeService} from './ctl-tms-tasinir-giris-bakiye.service';
import { CommonModule } from '@angular/common';
import { CtlSablonComponent } from '../ctl-sablon/ctl-sablon.component';
import { LabelMode } from 'devextreme/common';
import {DkDxDataCtlTableComponent} from "../../dk-dx-data-ctl-table/dk-dx-data-ctl-tablecomponent";
import { UtilsService } from '../../../services/utils.service';
import {TmsTifCikis} from "@dabnet-kamu/tms";

@Component({
  selector: 'dk-ctl-tms-tasinir-giris-bakiye',
  standalone: true,
  imports: [
    DxTextBoxModule,
    DxButtonModule,
    CtlTmsTasinirGirisBakiyeAramaComponent,
    CommonModule,
    DxPopupModule,
    DxScrollViewModule,
    CtlSablonComponent,
    DxToastModule,
    DkDxDataCtlTableComponent
  ],
  providers: [TmsTasinirGirisBakiyeService],
  templateUrl: './ctl-tms-tasinir-giris-bakiye.component.html',
  styleUrls: ['./ctl-tms-tasinir-giris-bakiye.component.scss'],
})
export class CtlTmsTasinirGirisBakiyeComponent implements OnInit, OnChanges {
  @ViewChild(CtlSablonComponent) ctlSablonComponent: CtlSablonComponent;
  @Input() labelText = "";
  @Input() labelMode:LabelMode = null;
  public crudPopupVisible = false;
  public title!: string;
  @Input() isReadOnly = false;
  @Input() inputArea = true;
  @Input() inputAreaPlaceholder='Tif Çıkış Seçiniz';
  public isFirst = true;
  public toastMessage: string;
  public toastVisible = false;
  public showAction = true;
  public data: any;
  @Input() code: any;
  @Input() donem: any;
  @Input() state: any;
  @Input() public islemFisCikisRowData:any
  @Input() public selectedDetayRowInfo:any
  @Input() public newTasinirCikisi!:any;
  @Input() ambarKod!: number;
  @Input() validationRulesMap!:any[];
  @Input() validationV2= false;
  @Input() warningMessage: string | null = null;
  @Output() public dataResult: EventEmitter<any> = new EventEmitter();

  constructor(private service: TmsTasinirGirisBakiyeService, private utilsService: UtilsService) {

  }

  ngOnInit(): void {
    if(this.state==='New'){
      this.service.getDlist('vTmsTasinirGirisBakiyeSrch');
    }else{
      this.service.getDlist('vTmsTasinirGirisBakiye');
    }
    if (!this.donem) {
      this.toastMessage = "Dönem Seçili Değil."
      this.showAction = false
    }
    else if (this.code) {
      this.getData(this.code,true);
    }


  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['donem']) {
      if(this.donem == null) this.showAction = false
      else{
        this.showAction = true
        this.service.setParams(this.ambarKod, this.donem)
      }
    }
    if(changes['ambarKod']){
      this.service.setParams(this.ambarKod, this.donem)
    }

  }



  searchClick() {
    if(this.showAction) this.crudPopupVisible = true
    else this.toastVisible = true
  }

  clear() {
    this.title = '';
    this.code = '';
    this.data = null;
    this.dataResult.emit(null);
  }

  handleValueChange(e: any) {
    if(this.showAction){
      if (e === '' || e === null) this.clear();
      else if(!this.isFirst) this.getData(e);
    this.isFirst = false;
    }
    else this.toastVisible = true
  }

  getData(code: any, isSetData?: boolean) {
    this.service.getData(code, this.donem, this.ambarKod, isSetData).then(res=>{
      res.load().then(response=>{
        if (response.length > 0) {
        this.title = response[0].TasinirAdi;
        this.code = response[0].TasinirKod;
          this.dataResult.emit(response[0]);
        } else if (this.code.length > 0) {
        this.utilsService.showError('Bulunamadı');
        this.clear();
      }
      })
    })
  }

  closePopupAfter(result: any, sablonCmp: CtlSablonComponent) {
    if (result?.selectedRowsData) {
      //this.code = result[0].TasinirKod
      //this.title = result[0].TasinirAdi
      this.dataResult.emit(result.selectedRowsData);
    }else if(result?.data){
      this.code = result.data.TasinirKod
      this.title = result.data.TasinirAdi
      this.dataResult.emit([result.data]);
    }
    else {
      this.dataResult.emit(null);
    }
    this.crudPopupVisible = false;
    setTimeout(() => {
      sablonCmp.focusInput();
    });
  }
}

